/* eslint-disable no-unused-vars */
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import themeColors from '../../assets/styles/themeColors';
import MetalStreamReviewData from '../../pages/MetalStream/MetalStreamReviewData';
import { selectSettings } from '../../store/selectors/settingsSelectors';
import { Heading } from '../Heading';

const Container = styled.div`
  margin-top: 1.5rem;
  background-color: ${themeColors.colorBackgroundSecondary};
  padding: 1.5rem;
`;

const GlobalContainer = styled.div`
  margin-top: 1.5rem;
`;
const ScheduledDate = styled.div`
  margin-bottom: 1.5rem;
  color: ${themeColors.colorTextGrey};
`;

const FundMetalReview = () => {
  const { t } = useTranslation();
  const d = new Date();
  const month = d.getMonth();
  const day = d.getDay();
  const { MetalStreamRecurringInvestment } = useSelector(selectSettings);
  const shouldDisplayNextMonth = day > MetalStreamRecurringInvestment;
  const currentMonth = month + 1;
  const nextMonth = month === 11 ? 0 : month + 2;
  return (
    <GlobalContainer>
      {' '}
      <Heading mb={16}>{t('standardReview.recurringInfo')}</Heading>
      <Container>
        <ScheduledDate>
          Scheduled {shouldDisplayNextMonth ? nextMonth : currentMonth}/
          {MetalStreamRecurringInvestment}
        </ScheduledDate>
        <MetalStreamReviewData />
      </Container>
    </GlobalContainer>
  );
};

export default FundMetalReview;
